import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next';
import WorkflowStartSelect from '../components/WorkflowStartSelect';

class WorkflowStart extends Component {

    constructor(props)
    {
        super(props)
    }

    render() {
        return this.props.isLegacy? (
            <div>

                <h3>How would you like to get started?</h3>
                <div className="d-flex justify-content-center">
                    <WorkflowStartSelect iconClassName="fa fa-copy" title="Start from Template" text="Choose from our library of ready-to-use workflow templates" onClick={() => { this.props.history.push("/templates"); }} />
                    <WorkflowStartSelect iconClassName="fa fa-file" title="Start from Scratch" text="Build a workflow from scratch" onClick={() => { this.props.history.push("/workflow/new"); }} />
                    <WorkflowStartSelect iconClassName="fa fa-play" title="Continue" text="Continue the workflow you've been building" onClick={() => { this.props.history.push("/workflow"); }} />
                </div>

            </div>
        ) : (
            <div>

                <h3>How would you like to get started?</h3>
                <div className="d-flex justify-content-center" style={{flexWrap: 'wrap'}}>
                    <WorkflowStartSelect iconClassName="fa fa-copy" title="Start from Template" text="Choose from our library of ready-to-use workflow templates" onClick={() => { this.props.history.push("/templates"); }} />
                    <WorkflowStartSelect iconClassName="fa fa-file" title="Start from Scratch" text="Build a workflow from scratch" onClick={() => { this.props.history.push("/workflow/new"); }} />
                    <WorkflowStartSelect iconClassName="fa fa-play" title="Continue" text="Continue the workflow you've been building" onClick={() => { this.props.history.push("/workflow"); }} />
                </div>

            </div>
        )
    }
}
export default withRouter(withTranslation()(WorkflowStart), WorkflowStart);